var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompany04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 28,
    viewBox: "0 0 19 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.150391 9.18042C0.150391 14.3765 4.35349 18.5994 9.56607 18.5994V9.18042H0.150391Z",
    fill: "#2196F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.150391 18.5811C0.150391 23.7771 4.35349 28.0001 9.56607 28.0001V18.5811H0.150391Z",
    fill: "#FFC107"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58398 9.18042C14.7782 9.18042 18.9997 13.385 18.9997 18.5994H9.58398V9.18042Z",
    fill: "#FFC107"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9997 18.5811C18.9997 23.7771 14.7966 28.0001 9.58398 28.0001V18.5811H18.9997Z",
    fill: "#F44336"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9997 9.41902C18.9997 4.22295 14.7966 0 9.58398 0V9.41902H18.9997Z",
    fill: "#FFC107"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.150391 9.41902C0.150391 4.22295 4.35349 0 9.56607 0V9.41902H0.150391Z",
    fill: "#F44336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany04);
export default __webpack_public_path__ + "static/media/company-04.bcb6655f3b18cc5bb27dc9d8edc2d3d8.svg";
export { ForwardRef as ReactComponent };